package com.macrofocus.eflux.components.link

import deckgl.util.calculateZoomLevel
import kotlinx.browser.window
import mui.material.Button
import mui.material.Link
import mui.system.sx
import org.locationtech.jts.geom.Geometry
import react.FC
import react.Props
import web.cssom.None
import web.cssom.px

external interface OpenInfraMapLinkProps : Props {
    var geometry: Geometry?
    var margin : Double?
    var zoomLevel : Double?
}

val OpenInfraMapLink = FC<OpenInfraMapLinkProps> { props ->
    Link {
        sx {
            textTransform = None.none
            paddingTop = 0.px
            paddingBottom = 0.px
        }

        component = Button
        onClick = {
            val physicalGeometry = props.geometry
            if(physicalGeometry != null) {
                val envelope = physicalGeometry.envelopeInternal
                val zoom = props.zoomLevel ?: calculateZoomLevel(
                    envelope.minX,
                    envelope.minY,
                    envelope.maxX,
                    envelope.maxY,
                    window.innerWidth,
                    window.innerHeight,
                    props.margin ?: 0.05
                )
                val url = "https://openinframap.org/#${zoom}/${physicalGeometry.centroid.y}/${physicalGeometry.centroid.x}"
                window.open(url, "_blank")
            }
        }

        +"Open Infrastructure Map"
    }
}